/**
 * Compatibility adapter for `query-string` v9 (ESM-only).
 *
 * Import from `utils/query-string` instead of `query-string` so we can:
 * - use a single default import (v9 exposes no Node named exports)
 * - keep `ParsedQuery` array values free of `null` entries (v6-era typing)
 */ import queryString from 'query-string';
const normalizeParsedQuery = (parsed)=>{
    const normalized = {};
    Object.entries(parsed).forEach(([key, value])=>{
        normalized[key] = Array.isArray(value) ? value.filter((item)=>item !== null) : value;
    });
    return normalized;
};
export function parse(query, options) {
    return normalizeParsedQuery(queryString.parse(query, options));
}
export const stringify = queryString.stringify;
